"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _icons = require("@material-ui/icons");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
// import DropDown from './dropDrown.svg'

function SelectFilter(_ref) {
  let {
    filterOptions,
    option,
    onOptionSelect
  } = _ref;
  const useStyles = (0, _styles.makeStyles)(theme => ({
    formControl: {
      minWidth: 90
    },
    select: {
      height: 34,
      background: '#EEEEEE',
      color: 'rgba(33, 37, 41, 1)',
      padding: 0,
      borderRadius: 0,
      borderRight: '1px solid #E5E5E5',
      borderLeft: '1px solid #E5E5E5',
      fontFamily: 'var(--leme-typography-family)',
      fontSize: 16,
      fontWeight: 400,
      letterSpacing: 0.15,
      borderTopLeftRadius: 4,
      borderBottomLeftRadius: 4,
      '& .MuiSelect-select.MuiSelect-select': {
        padding: '6px 32px 2px 9px'
      },
      '& .MuiSelect-selectMenu': {
        textOverflow: 'initial'
      },
      '& .MuiSelect-icon': {
        top: 0,
        color: theme.palette.text.primary,
        padding: '4.5px 6px',
        cursor: 'pointer',
        transform: 'none !important'
      }
    },
    item: {
      maxHeight: 36,
      minWidth: 86
    },
    options: {
      marginTop: 2,
      boxShadow: '0px 5px 5px -3px rgba (0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)!important',
      borderRadius: '4px!important',
      minWdth: 86,
      '& .MuiList-padding': {
        paddingTop: 8,
        paddingBottom: 9,
        fontSize: 16
      },
      '&.MuiSelect-iconOpen': {
        transform: 'none !important'
      }
    },
    TypographyEllipsis: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }));
  const CustomDropDown = (0, _styles.withStyles)()(_ref2 => {
    let {
      className
    } = _ref2;
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(_icons.FilterListRounded, null));
  });
  const classes = useStyles();
  const handleOptionSelect = opt => {
    onOptionSelect(opt);
  };
  return /*#__PURE__*/React.createElement(_core.FormControl, {
    className: classes.formControl
  }, /*#__PURE__*/React.createElement(_core.Select, {
    id: "select-filter",
    value: option ? option.value : 'Todos',
    className: classes.select,
    MenuProps: {
      classes: {
        paper: classes.options
      },
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      },
      getContentAnchorEl: null
    },
    defaultValue: option,
    disableUnderline: true,
    IconComponent: CustomDropDown
  }, filterOptions && filterOptions.map(opt => /*#__PURE__*/React.createElement(_core.MenuItem, {
    className: classes.item,
    key: `${opt.value}+${Math.random()}`,
    onClick: () => handleOptionSelect(opt),
    value: opt.value
  }, /*#__PURE__*/React.createElement(_core.Typography, {
    variant: "body1",
    className: classes.TypographyEllipsis
  }, opt.label)))));
}
SelectFilter.propTypes = {
  /** Lista de opções para o filtro select */
  filterOptions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string || _propTypes.default.number
  })).isRequired,
  /** Método responsável por alterar e selecionar a opção do filtro  */
  onOptionSelect: _propTypes.default.func.isRequired,
  /** Opção selecionada no filtro */
  option: _propTypes.default.string
};
SelectFilter.defaultProps = {
  option: ''
};
var _default = exports.default = SelectFilter;